import {BackgroundVideoOptionsArray} from '../../../types';
import React from 'react';
import styled from 'styled-components';
import {Video} from './Video';
import {isValidMediaOptions} from '../../../utils';
import {WithCaptionProps} from '../../wraps/caption/WithCaption.wrap';

const Styled = styled.div`
    &.ratio-keeper {
        padding-bottom: 56.25%;
        position: relative;
    }
    .video-wrap {
        background-color: black;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        .video-wrapper {
            overflow: initial;
        }
        .screen,
        .screen > div,
        iframe {
            height: 100%;
            width: 100%;
            background-color: black;
        }
    }
`;

interface RatioKeptVideoProps {
    mediaOptions?: BackgroundVideoOptionsArray;
    placeholderImageCaption?: WithCaptionProps;
    mute?: boolean;
    forcePlay?: boolean;
    controls?: boolean;
    autoplay?: boolean;
}

export const RatioKeptVideo = ({
    mediaOptions,
    placeholderImageCaption,
    mute = true,
    forcePlay,
    autoplay,
    controls = true
}: RatioKeptVideoProps): JSX.Element | null => {
    if (!isValidMediaOptions(mediaOptions)) return null;

    return (
        <Styled className="ratio-keeper">
            <div className="video-wrap">
                <Video
                    mediaOptions={mediaOptions}
                    placeholderImageCaption={placeholderImageCaption}
                    controls={controls}
                    forcePlay={forcePlay}
                    mute={mute}
                    forceVideoMobile
                    enableRatioHelper={false}
                    autoplay={autoplay}
                />
            </div>
        </Styled>
    );
};
